var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c("el-input", {
                staticClass: "width-2x",
                attrs: { type: "text", "auto-complete": "off" },
                on: {
                  blur: function($event) {
                    _vm.changeDesc()
                  }
                },
                model: {
                  value: _vm.servcWorkImg.desc,
                  callback: function($$v) {
                    _vm.$set(_vm.servcWorkImg, "desc", $$v)
                  },
                  expression: "servcWorkImg.desc"
                }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c("el-input", {
                staticClass: "width-1-5x bottom-line",
                attrs: { disabled: true },
                model: {
                  value: _vm.servcWorkImg.tagName,
                  callback: function($$v) {
                    _vm.$set(_vm.servcWorkImg, "tagName", $$v)
                  },
                  expression: "servcWorkImg.tagName"
                }
              }),
              _vm._v(" "),
              _c("i", {
                staticClass:
                  "icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                on: {
                  click: function($event) {
                    _vm.setTag($event)
                  }
                }
              }),
              _vm._v(" "),
              _vm.servcWorkImg.tagName != null
                ? _c(
                    "i",
                    {
                      staticClass: "input-deletable",
                      on: { click: _vm.removeCancel }
                    },
                    [_vm._v("×")]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "swb-dt-popover",
        { ref: "attPopoverRef", attrs: { classes: "popper-tabs" } },
        [
          _c("swb-att-tag-list-for-select", {
            ref: "swb_att_tag_list_for_select",
            attrs: { attAspect: _vm.attAspect, selectName: _vm.tagName },
            on: {
              "notity-attTag-comfirm": _vm.doAttTagConfirm,
              "notity-attTag-cancel": _vm.doAttTagCancel
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("文件名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("设置标签")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1296740b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1296740b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/ServcWorkImgFileUpdate.vue
// module id = 2856
// module chunks = 0